import ajax from '@/libs/ajax'
import Config from '@/config/index'
import store from '@/store/index'

/**
 * 获取下载文件URL接口
 * @param  {String}  fileId    待下载文件的ID
 * @param  {String}  localName 下载文件的本地文件名
 * @param  {Boolean} useOss    是否启用OSS功能，只有该参数为true，且后端的useOSS参数都为true时才会启用OSS功能
 * @return {Object}            Promise对象，该对象的then方法的回调函数的参数为请求的应答对象（{code: '0', data: { useOss: true, url: 'https://....' }, message: '成功'}）。当应答中的data.useOss为false时，data.url为“'/v1/files/download/' + fileId”；data.useOss为true时，data.url为以“https://”开头的完整下载地址
 */
export const getFileUrl = (fileId, localName, useOss = true, singlePatch = false) => {
  let noOssUrl = '/v1/files/security/download'
  fileId = fileId.toString()
  if (fileId.split(',').length > 1 || !useOss) {
    return Promise.resolve().then(() => {
      return {
        code: '0',
        data: {
          useOss: false,
          url: noOssUrl,
          method: 'GET',
          data: {
            pkFiles: fileId.split(','),
            fileName: localName,
            singlePatch
          }
        }
      }
    })
  }
  return ajax.get('/v1/files/oss/sts/download/presigned-url', {
    params: {
      pkFile: fileId,
      localFileName: localName,
      _t: new Date().getTime()
    }
  }).then(res => {
    if (res && res.code === '0') {
      if (!res.data.useOss || !useOss) {
        res.data.url = noOssUrl
        res.data.method = 'POST'
        res.data.data = {
          pkFiles: fileId.split(','),
          fileName: localName,
          singlePatch
        }
      }
    }
    return res
  })
}
/**
 * 下载指定ID的文件
 * @param  {String}  fileId    待下载文件的ID
 * @param  {String}  localName 下载文件的本地文件名
 * @param  {Boolean} useOss    是否启用OSS功能，只有该参数为true，且后端的useOSS参数都为true时才会启用OSS功能
 * @return {Object}            Promise对象，该对象的then方法的回调函数的参数为undefined
 */
function downloadFile (fileId, localName, useOss = true, singlePatch = false) {
  return getFileUrl(fileId, localName, useOss, singlePatch).then(res => {
    if (res && res.code === '0') {
      let url = res.data.useOss && useOss ? res.data.url : Config.baseUrl + res.data.url
      saveFile(url, res.data.useOss && useOss ? undefined : res.data.data, res.data.useOss && useOss, res.data.method)
    }
    return res
  })
}
/**
 * 下载指定URL的文件
 * @param {String} url 待下载文件的URL
 * @param {Object} params 请求参数，GET请求为查询参数，POST请求为请求体参数，默认为空对象
 * @param {Boolean} decode 是否对query参数解码，默认为false
 * @param {String} method 请求方式，默认为GET
 */
function saveFile(url, params = {}, decode = false, method = 'GET') {
  // 用户信息加密
  let user = store.state.corpInfo.user
  let userInfoStr =  `uwhU0Nssjf${user.personId}${user.idCode}${user.userId}RgBI104Y6K`
  let [path, searchParams] = url.split('?');
  let form = document.createElement('form');
  form.setAttribute('style', 'display:none');
  form.setAttribute('method', method)
  form.setAttribute('target', '');
  let actionUrl = method.toUpperCase() === 'POST' ? path + '?userInfoMD5=' + md5(userInfoStr) : path
  form.setAttribute('action', actionUrl);
  if(searchParams) {
    searchParams.split('&').forEach(param => {
      let input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      let [key, value] = param.split('=')
      input.setAttribute('name', key);
      input.setAttribute('value', value ? (decode ? window.decodeURIComponent(value) : value) : '');
      form.appendChild(input);
    });
  }
  if (params) {
    // eslint-disable-next-line eqeqeq
    Object.keys(params).filter(key => params[key] != undefined).forEach(key => {
      let value = params[key]
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          let input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', method === 'GET' ? key: (key + '[' + index + ']'))
          input.setAttribute('value', item)
          form.appendChild(input)
        })
      } else {
        let input = document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', key)
        input.setAttribute('value', value)
        form.appendChild(input)
      }
    })
  }
  if (method.toUpperCase() === 'GET') {
    let input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'userInfoMD5')
    input.setAttribute('value', md5(userInfoStr))
    form.appendChild(input);
  }
  let body = document.getElementsByTagName('body')[0];
  body.appendChild(form);
  form.submit();
  body.removeChild(form);
}
export default {
  getFileUrl,
  downloadFile,
  saveFile
}